import $ from 'jquery';
import MagnificPopup from 'magnific-popup';
import changeWindowUrl from './utils/change-url';

class FiguresPopup {
    constructor($selector) {
        this.$figures = $selector;
        this.$figures = this.$figures.filter(function () {
            return $(this).find('img').length || $(this).find('table').length || $(this).find('.c-embed-code').length;
        });

        if (this.$figures.length) {
            this.$figures.on('click', $.proxy(this.showPopup, this));
        }
    }

    showPopup(e) {
        const $elem = $(e.currentTarget);

        //decide magnific type based on figure content
        let magnificItemType = 'image';
        if ($elem.find('iframe').length || $elem.find('.c-embed-code').length) {
            magnificItemType = 'iframe';
        }

        // Get ID of clicked figure and add to hash
        const figureId = $elem.attr('id');
        const $popup = $('<div class="c-figure-popup js-popup"></div>');
        $popup.append($elem.parent().clone());

        const magnificSrc = `<div class="popup-container">${$popup.html()}`;

        $.magnificPopup.open({
            items: {
                src: magnificSrc,
                type: 'inline',
            },
            type: magnificItemType,
            closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close the overlay"></button>',
            // Below code required for preventing scroll on iOS
            fixedContentPos: true,
            callbacks: {
                beforeOpen: function () {
                    $('body').addClass('mfp-active');
                },
                beforeClose: function () {
                    $('body').removeClass('mfp-active');
                }
            }
        });
    }

}

export default FiguresPopup;
